// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pixels-form{
    display: flex;
    border: 1px solid #343A40 ;
    border-radius: 5px;
    padding: 10px 10px;
    position: relative;
}

.pixels-form .submit{
    position: absolute;
    bottom: 5px;
    right: -5px;
    /* justify-self: end; */
}

.options-container{
    display: flex;
    justify-content: space-between;
    width: 95%;
    margin-bottom: 15px;
}

.download-button:hover{
    cursor: pointer;
    background-color: #DEE2E6;
}

.list-container .single-list{
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
}


.description{
    display: flex;
    flex-direction: column;
}

.description span{
    color:  red;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 12px;
    margin-top: 5px;
}

.type-priority select{
    margin: 5px 0px;
}

.options-container select{
    margin: 0px 10px;
}

.des-container input[type='text']{
    width: 90%;
}

.type-container span{
    color:  red;
    font-size: 12px;
}

.priority-container span{
    color: red;
}

.tactic{
    display: flex;
    margin-left: 10px;
}

.tactic span{
    color: red;
    font-size: 12px;
}

.buttons{
    margin-right: 10px;
    display: flex;
    width: 150px;
    justify-content: space-around;
}

.buttons button{
    padding: 2px 5px;
}

.input-label{
    margin-right: 3px;
}

.options-container select{
    margin: 0px 7px;
}`, "",{"version":3,"sources":["webpack://./src/styles/pixels.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".pixels-form{\n    display: flex;\n    border: 1px solid #343A40 ;\n    border-radius: 5px;\n    padding: 10px 10px;\n    position: relative;\n}\n\n.pixels-form .submit{\n    position: absolute;\n    bottom: 5px;\n    right: -5px;\n    /* justify-self: end; */\n}\n\n.options-container{\n    display: flex;\n    justify-content: space-between;\n    width: 95%;\n    margin-bottom: 15px;\n}\n\n.download-button:hover{\n    cursor: pointer;\n    background-color: #DEE2E6;\n}\n\n.list-container .single-list{\n    margin: 10px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n\n\n.description{\n    display: flex;\n    flex-direction: column;\n}\n\n.description span{\n    color:  red;\n    margin-left: 5px;\n    margin-right: 5px;\n    font-size: 12px;\n    margin-top: 5px;\n}\n\n.type-priority select{\n    margin: 5px 0px;\n}\n\n.options-container select{\n    margin: 0px 10px;\n}\n\n.des-container input[type='text']{\n    width: 90%;\n}\n\n.type-container span{\n    color:  red;\n    font-size: 12px;\n}\n\n.priority-container span{\n    color: red;\n}\n\n.tactic{\n    display: flex;\n    margin-left: 10px;\n}\n\n.tactic span{\n    color: red;\n    font-size: 12px;\n}\n\n.buttons{\n    margin-right: 10px;\n    display: flex;\n    width: 150px;\n    justify-content: space-around;\n}\n\n.buttons button{\n    padding: 2px 5px;\n}\n\n.input-label{\n    margin-right: 3px;\n}\n\n.options-container select{\n    margin: 0px 7px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
